<div *ngIf="show" class="tp-error">{{ errorMessage }}</div>
